@if (!editMode() && applicationStateService.userData.isTeacher) {
    <h3 class="title">
        <img [src]="'sidebar/test-generator.png' | asset">
        Tests & Wiederholungen
    </h3>
}
<div class="homework-add">
    <div [class.hide-xs]="chooserOpened">

        @if (!editMode()) {
            <button (click)="toggle()" [class.teacher]="applicationStateService.userData.isTeacher"
                    class="title btn btn-round btn-open btn-semibold m-auto">
                Neuen Test erstellen
                <i class="fas fa-pencil-alt"></i>
            </button>
        }
        @if (editMode()) {
            <button (click)="toggle()" class="back-btn"><span class="triangle-left "></span>
                Zur Liste
            </button>
        }
        <!--        <div class="note" *ngIf="editMode()">-->
        <!--            <h4><i class="fas fa-lightbulb-on"></i> Hinweis</h4>-->
        <!--            <p>-->
        <!--                Bitte klicke auf "Test/Schularbeit erstellen" bevor du die Sidebar schließt, andernfalls gehen deine-->
        <!--                Eingaben verloren.-->
        <!--            </p>-->
        <!--            <p>-->
        <!--                Tests/Schularbeiten können nach Erstellung weiter bearbeitet werden.-->
        <!--            </p>-->
        <!--        </div>-->
        @if (editMode()) {
            <form>
                <div>
                    @if (!editHomework) {
                        <h2>Neuer Test erstellen</h2>
                    }
                    @if (editHomework) {
                        <h2>{{ editHomework.title }} bearbeiten</h2>
                    }
                    <div class="input-group display-block">
                        <div class="dropdown book-dropdown">
                            <button [innerHTML]="(selectedBook?.title || 'Buch auswählen')" aria-expanded="false"
                                    aria-haspopup="true"
                                    class="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown"
                                    id="dropdownMenuButton"
                                    type="button">
                            </button>
                            <ul aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                @for (book of bookData; track book) {
                                    <li [class.active]="book === selectedBook">
                                        <button (click)="onBookChanged(book)"
                                            class="pointer btn-no-style"
                                            type="button"
                                        >
                                            <div>
                                                @if (book.coverPath) {
                                                    <img [src]="book.coverPath" alt="Buchcover"
                                                         class="align-self-center">
                                                }
                                                @if (!book.coverPath) {
                                                    <div class="dummy-image">Alle</div>
                                                }
                                                <div [innerHTML]="book.title | ellipsis : 60"></div>
                                                @if (book === selectedBook) {
                                                    <div>
                                                        <i class="fa fa-check fas"></i>
                                                    </div>
                                                }
                                            </div>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <label for="homeworkNumber">Beispiele hinzufügen</label>
                    <div class="input-group dropdown open" (blur)="focusOut()">
                        <input (focus)="focusDropdown = true;" (keyup)="keyUpExercise($event)"
                               [(ngModel)]="exercise"
                               autocomplete="off" class="form-control"
                               id="homeworkNumber" name="homeworkNumber" placeholder="Beispiel, Check-In, ..."
                               type="text"/>
                        @if (hsmLinks && hsmLinks.length > 0 && focusDropdown) {
                            <ul aria-labelledby="dropdownLink"
                                class="suggestions-dropdown list-group overflow-scroll position-absolute w-100 start-0 top-100"
                                style="z-index: 100;height: 40vh;max-height: 80vh;"
                            >
                                @for (resultWrapper of hsmLinks; track resultWrapper) {
                                    <li class="m-0 p-0 list-group-item bg-white">
                                        <div class="dropdown-header d-flex align-items-center">
                                            @if (resultWrapper.bookWrapper.coverPath) {
                                                <img [src]="resultWrapper.bookWrapper.coverPath" alt="Buchcover"
                                                     width="40px">
                                            }
                                            <span style="white-space: normal;">{{ resultWrapper.bookWrapper.title }}</span>
                                        </div>
                                        <ul class="dropdown-menu show w-100 rounded-0 overflow-visible position-relative shadow-none mh-100">
                                            @for (result of resultWrapper.hsmLinks; track result) {
                                                <li class="dropdown-item border-bottom pointer pe-3">
                                                    <button (click)="addResult(result.text)"
                                                        class="btn-no-style d-flex w-100"
                                                    >
                                                        <div class="dropdown-item-text">
                                                            <span>{{ result.text }}</span>
                                                        </div>
                                                        <img [src]="'icon-hsm-plusbutton.png' | asset"
                                                             alt="Quicklink zur Aufgabe hinzufügen">
                                                    </button>
                                                </li>
                                            }
                                        </ul>
                                    </li>
                                }
                            </ul>
                        }
                        <span class="input-group-addon" id="basic-addon">
                            <img (click)="onPlus()" [src]="'icon-hsm-plusbutton.png' | asset"
                                 alt="Beispiel hinzufügen" class="homework-img"/>
                        </span>
                    </div>
                    @if (homeworkService.loadingIndicator) {
                        <div>
                            <img [src]="'sidebar/spinner-blue.svg' | asset" alt="Beispiele werden geladen..."
                                 class="spinner"/> Beispiele werden geladen...
                        </div>
                    }
                    <ul class="exercise-list">
                        @for (link of homeworkService.formAddedTests; track link) {
                            <li (dragend)="handleDragEnd($event)"
                                (dragenter)="handleDragEnter($event)"
                                (dragleave)="handleDragLeave($event)"
                                (dragover)="handleDragOver($event)"
                                (dragstart)="handleDragStart($event, link)"
                                (drop)="handleDrop($event, link)"
                                draggable="true">
                                <div class="exercise-item">
                                    <div>
                                        <span class="exercise-text"><a (click)="openQuicklink(link)"
                                                                       href="#">{{ link.text }}</a></span>
                                        <br>
                                        <small>{{ link.teaser }}</small>
                                    </div>
                                    <button (click)="onMinus(link)" class="btn-no-style">
                                        <img alt="Beispiel entfernen" class="homework-img"
                                             src="{{ assetService.getUrl('icon-hsm-remove.png') }}"/>
                                    </button>
                                </div>
                            </li>
                        }
                    </ul>
                    <div>
                        @if (!homeworkService.formAddedTests || homeworkService.formAddedTests.length === 0) {
                            <span>Keine Beispiele ausgewählt</span>
                        }
                    </div>
                </div>
                <div class="homework-inputs">
                    <div class="form-group">
                        <label for="title">Titel (optional)</label>
                        <input [(ngModel)]="title" class="form-control" id="title" maxlength="255" name="homeworkTitle"
                               placeholder="Titel der Übung"
                               type="text"/>
                    </div>
                    <div class="search-field search-select">
                        <label for="cooldown">Test kann wiederholt werden...</label>
                        <select [(ngModel)]="cooldownPhase" class="select-field" id="cooldown" name="cooldown">
                            @for (option of cooldownPhaseOptions; track option.value) {
                                <option [ngValue]="option.value">nach {{ option.label }}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="email">Alle Abgaben schicken an:</label>
                        <input (change)="validateEmail()" (keyup)="debouncedValidateEmail()" [(ngModel)]="email"
                               class="form-control" id="email"
                               maxlength="255" name="homeworkMail" placeholder="E-Mail"
                               required
                               type="email"/>
                    </div>
                    @if (schoolClassService.hasClassesForNotification()) {
                        <div class="search-field search-select">
                            <label for="homeworkFormSchoolClasses">Klasse (optional)</label>
                            <select [(ngModel)]="schoolClass" class="select-field" id="homeworkFormSchoolClasses"
                                    name="school_class">
                                <option [selected]="true" [value]="0">-- keine Auswahl --</option>
                                @for (schoolClass of applicationStateService.schoolClassList; track schoolClass) {
                                    <option
                                            [value]="schoolClass.id">
                                        {{ schoolClass.name }} - {{ schoolClass.group }}
                                    </option>
                                }
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="homeworkFormNotifySchoolClassesText">Nachricht (optional)</label>
                            <input [(ngModel)]="notifySchoolClassText"
                                   class="form-control"
                                   id="homeworkFormNotifySchoolClassesText"
                                   name="notify_school_class_text"
                                   type="text"
                            />
                        </div>
                        <div class="form-group checkbox">
                            <label for="homeworkFormNotifySchoolClasses">
                                <input [(ngModel)]="notifySchoolClass"
                                       [value]="true"
                                       id="homeworkFormNotifySchoolClasses"
                                       name="notify_school_classes"
                                       type="checkbox"
                                > Klasse informieren (optional)
                            </label>
                        </div>
                    }
                    <button (click)="save(true)"
                            [disabled]="!homeworkService.formAddedTests || homeworkService.formAddedTests.length === 0 || !email || !validEmail || !isEdited"
                            class="btn btn-save-tests"
                            type="button">
                        Speichern@if (loading) {
                        <img
                                [src]="'sidebar/spinner-white.svg' | asset"
                                alt="Übung wird erstellt..."/>
                    }
                    </button>
                    @if (errorMessages.length > 0) {
                        <div class="errors alert alert-danger">
                            <ul>
                                @for (err of errorMessages; track err) {
                                    <li>{{ err }}</li>
                                }
                            </ul>
                        </div>
                    }
                </div>
            </form>
        }
        @if (editMode()) {
            <button (click)="toggle()" class="cancel-button">
                Abbrechen
            </button>
        }
    </div>

</div>
